import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Bold, SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('session')
  return (
    <div>
      <Title size="h2" color={COLORS.dark3} noWrap>
        {t('createPasswordModal.title')}
      </Title>
      <Separator weight={1} />
      <Grid align="center" justify="space-between" gutter={0.4}>
        <Col>
          <Icon name={'BsShieldLockFill'} color={COLORS.purple1} size={2.5} />
        </Col>
        <Col flex={1}>
          <Bold color={COLORS.dark3}>{t('createPasswordModal.subtitle')}</Bold>
          <SmallText color={COLORS.dark3}>{t('createPasswordModal.useFieldsBelow')}</SmallText>
        </Col>
      </Grid>
      <Separator weight={2} />
    </div>
  )
}

export default ModalHeader
